import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {
	TaskCategories,
	TaskCategoriesDisplayOrder
} from '../../util/uiconstants';
import {currentResource, labels} from '../../util/utils';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskCategoriesReducer(
	state = initialState.taskCategories,
	action
) {
	switch (action.type) {
		case types.GET_TASK_CATEGORIES: {
			let response;
			if (
				action.response &&
				action.response.categories &&
				action.response.categories.length > 0
			) {
				let categories = action.response.categories.map((category) => {
					if (
						category.id === TaskCategories.ExecutionGeneral &&
						!action.response.categories.find(function(category) {
							return (
								category.id === TaskCategories.ExecutionSCOTs ||
								category.id === TaskCategories.ExecutionITSOs ||
								category.id === TaskCategories.ExecutionAccounts
							);
						})
					) {
						return {
							...category,
							name: labels.taskCategoryExecution,
							displayOrder:
								TaskCategoriesDisplayOrder[TaskCategories[category.id]]
						};
					} else {
						return {
							...category,
							name: currentResource.taskNavigation[category.id],
							displayOrder:
								TaskCategoriesDisplayOrder[TaskCategories[category.id]]
						};
					}
				});

				let updatedcategories = categories.sort((a, b) =>
					(a.displayOrder > b.displayOrder) ? -1 : 1
				);
				response = {...action.response, categories:updatedcategories};
			}
			return response || null;
		}
		default: {
			return state;
		}
	}
}
